import { CandidateProfilePageComponent } from "./candidate-profile-page.component";
import { CandidateProfileModule } from "./candidateProfile/candidate-profile.module";
export const CandidateProfilePageModule = angular
    .module('candidateProfilePage', [CandidateProfileModule])
    .config(['$stateProvider',
    ($stateProvider) => {
        $stateProvider.state('missioncontrol.candidateprofile', {
            url: '/candidateProfile',
            component: CandidateProfilePageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                candidateId: null
            }
        });
    }
])
    .component(CandidateProfilePageComponent.selector, CandidateProfilePageComponent.component)
    .name;
//# sourceMappingURL=candidate-profile-page.module.js.map